import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FiBookOpen, FiCheckSquare, FiLayers, FiShoppingCart } from 'react-icons/fi';
import { isStudentAccount } from '../../mymod/accountRole';
import LearningReportButton from './LearningReportButton';
import './LearningActions.scss';

const studentActions = [
  { title: '디지털 1.0', path: '/lms/question-bank/digital', Icon: FiBookOpen },
  { title: '디지털 2.0', path: '/lms/question-bank/book', Icon: FiLayers },
  { title: '진단평가', path: '/lms/question-bank/exam', Icon: FiCheckSquare },
  { title: '교재 구매', path: '/storeBook', Icon: FiShoppingCart },
];

const LearningActions = ({ classCode }) => {
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.reduxStore.userInfo);

  return (
    <div className="digital-lms-learning-actions" role="group" aria-label="학습 바로가기">
      <LearningReportButton classCode={classCode} />
      {isStudentAccount(userInfo) && studentActions.map(({ title, path, Icon }) => (
        <button
          key={path}
          type="button"
          className="digital-lms-question-bank-button"
          onClick={() => navigate(path)}
        >
          <span className="digital-lms-question-bank-button__icon"><Icon aria-hidden="true" /></span>
          <strong>{title}</strong>
        </button>
      ))}
    </div>
  );
};

export default LearningActions;
